export const editableFields = [
  'form_contingent_do_child.queued_type',
  'form_contingent_do_child.child_iin',
  'form_contingent_do_child.child_surname',
  'form_contingent_do_child.child_name',
  'form_contingent_do_child.child_middlename',
  'form_contingent_do_child.child_birthday',
  'form_contingent_do_child.child_gender',
  'form_contingent_do_child.correction_type',
  'form_contingent_do_child.rehab_type',
  'form_contingent_do_child.privilege_type',
  'form_contingent_do_child.priority_queued',
  'form_contingent_do_child.status_direction',
  'form_contingent_do_child.status_voucher',
  'form_contingent_do_child.user_category',
  'form_contingent_do_child.user_surname',
  'form_contingent_do_child.user_name',
  'form_contingent_do_child.user_middlename',
  'form_contingent_do_child.user_birthday',
  'form_contingent_do_child.user_telephone_number',
  'form_contingent_do_child.user_email',
  'form_contingent_do_child.father_iin',
  'form_contingent_do_child.mother_iin',
  'form_contingent_do_child.parental_consent',
  'form_contingent_do_child.order_num',
  'form_contingent_do_child.order_date'
];

export const editableFieldsInStatusExpelled = [
  'form_contingent_do_child.date_dropout',
  'form_contingent_do_child.dropout_reason',
];